import { useEffect, useRef, useState } from 'react';

const NODES = [
  { label: 'قصص تفاعلية', icon: '📖', c: '#dd5f7a', left: 1548, top: 72, d: 0 },
  { label: 'امتحانات وأوراق عمل', icon: '📝', c: '#e0a21b', left: 1287, top: 290, d: 0.4 },
  { label: 'خطط دراسية ذكية', icon: '🎯', c: '#6b4fd8', left: 1242, top: 400, d: 0.8 },
  { label: 'تعليم يناسب طفلك', icon: '🧒', c: '#e8834a', left: 1225, top: 510, d: 1.2 },
  { label: 'المعلم وأولياء الأمور', icon: '👨‍👩‍👧', c: '#2e7d4f', left: 1234, top: 620, d: 1.6 },
  { label: 'المدرسة والوزارة', icon: '🏛️', c: '#2a9fe0', left: 1266, top: 722, d: 2.0 },
];

const PHRASES = [
  'طالب وأهل ومعلم ومدرسة ووزارة في نظام واحد',
  'دروس تتحول إلى قصص تفاعلية',
  'أول منصة فلسطينية تعليمية بالذكاء الاصطناعي',
  'قرارات مبنية على البيانات لا على التقدير',
];

const TAGS = ['تفكير نقدي', 'تحليل لحظي', 'خطط مخصصة', 'متابعة يومية'];

const Headline = ({ view }) => (
  <h1 className="hl" data-testid={`hero-${view}-headline`}>
    رشيد.. تعليم <em className="pink">يفهمك</em> قبل أن يعلّمك
  </h1>
);

const Tags = ({ view }) => (
  <div className="tags" data-testid={`hero-${view}-tags`}>
    {TAGS.map((t, i) => <span key={i} data-testid={`hero-${view}-tag-${i}`}>{t}</span>)}
  </div>
);

export const HeroAnimated = () => {
  const heroRef = useRef(null);
  const cvRef = useRef(null);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % PHRASES.length), 2800);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const fit = () => {
      const h = heroRef.current;
      const c = cvRef.current;
      if (!h || !c) return;
      const W = h.clientWidth;
      if (W <= 900) { h.style.height = 'auto'; c.style.transform = ''; c.style.left = ''; c.style.top = ''; return; }
      const s = W / 1893;
      c.style.transform = `scale(${s})`;
      c.style.left = '0px';
      c.style.top = '0px';
      h.style.height = (803 * s) + 'px';
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, []);

  const subtitle = 'يحلل أداء الطالب، ويبني له خطة دراسية تناسبه، ويمنح الأهل والمعلم والمدرسة والوزارة صورة واضحة لكل خطوة.';

  return (
    <div className="rhero" ref={heroRef} data-testid="hero-animated">
      <div className="cv" ref={cvRef} data-testid="hero-desktop-canvas">
        <img alt="طالبة تحمل دفاتر" src="/hero-rasheed.jpg" data-testid="hero-desktop-image" />
        <svg className="eg" viewBox="0 0 1893 803">
          <circle className="tk" cx="1665" cy="527" r="482" pathLength="100" />
          <circle className="rn" cx="1665" cy="527" r="482" pathLength="100" />
        </svg>
        {NODES.map((n, i) => (
          <div key={i} className="n" style={{ left: `${n.left}px`, top: `${n.top}px`, '--c': n.c, '--d': `${n.d}s` }} data-testid={`hero-desktop-feature-${i}`}>
            <b>{n.label}</b>
            <div className="o"><i>{n.icon}</i></div>
          </div>
        ))}

        {/* Left headline block (scales with the image) */}
        <div className="txt">
          <Headline view="desktop" />
          <div className="rot2"><span key={idx} className="rotline" data-testid="hero-desktop-rotating-text">{PHRASES[idx]}</span></div>
          <p className="sub" data-testid="hero-desktop-subtitle">{subtitle}</p>
          <Tags view="desktop" />
        </div>
      </div>

      {/* Mobile fallback */}
      <div className="m" data-testid="hero-mobile-content">
        <div className="mobile-art"><img src="/hero-rasheed.jpg" alt="طالبة تحمل دفاتر" data-testid="hero-mobile-image" /></div>
        <Headline view="mobile" />
        <div className="rot2"><span key={idx} className="rotline" data-testid="hero-mobile-rotating-text">{PHRASES[idx]}</span></div>
        <p className="sub" data-testid="hero-mobile-subtitle">{subtitle}</p>
        <Tags view="mobile" />
        <ul data-testid="hero-mobile-features">
          {NODES.map((n, i) => (
            <li key={i} style={{ '--c': n.c }} data-testid={`hero-mobile-feature-${i}`}><i>{n.icon}</i><span>{n.label}</span></li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HeroAnimated;
